var map = {
	"./BusinessintheTimeofContagion.jpeg": 580,
	"./LakshmiSubramanian.png": 581,
	"./LouizaRodrigues.png": 582,
	"./MadMenofBombay.png": 583,
	"./PowerPrivilegePosture.jpeg": 584,
	"./SaritaSundar.png": 585,
	"./Speaker1.png": 586,
	"./TheGlobalBlueJeansTransformation.jpg": 587,
	"./TimberTradeTrajectory.jpeg": 588,
	"./TraceyPanek.png": 589,
	"./TypewriterTipTip.png": 590,
	"./WilliamMazzarella.png": 591,
	"./details-banner/BusinessInTheTimeOfContagion.png": 592,
	"./details-banner/MadMenOfBombay.png": 593,
	"./details-banner/PowerPrivilegeposture.png": 594,
	"./details-banner/TheGlobalBlueJeans.png": 595,
	"./details-banner/TimberTradeTrajectory.png": 596,
	"./details-banner/TypewriterTipTip.png": 597
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 579;